module.exports = "/assets/6be3e24e4c9d6a4853cb3407051b8edf.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/UX.png
// module id = 3026
// module chunks = 0